export default function Logo() {
	return (
		<div className="glow h-full flex items-center justify-center">
			<img
				alt="KM DEVELOPMENT LOGO"
				src="/images/badge_dark.svg"
				className="h-full z-10 relative"
			/>
			<span></span>
			<span></span>
		</div>
	);
}
